import { fromPromise } from 'xstate5';

import { type ForgotToScanInput, type ForgotToScanResponse } from '../utils';

const submitForm = fromPromise<ForgotToScanResponse, ForgotToScanInput>(async () => {
  throw new Error('Not implemented');
});

export const Actors = {
  submitForm,
};
